import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

// Demo users seeded in localStorage
const SEED_USERS = [
  { id: 1, name: 'Admin User', email: 'admin@nextgenhub.tech', password: 'Admin@123', role: 'admin', avatar: 'AU', createdAt: '2024-01-15' },
  { id: 2, name: 'Ravi Kumar',  email: 'ravi@demo.com',  password: 'Demo@123',  role: 'client', avatar: 'RK', createdAt: '2024-06-10' },
];

function getUsers() {
  const stored = localStorage.getItem('nc_users');
  if (!stored) {
    localStorage.setItem('nc_users', JSON.stringify(SEED_USERS));
    return SEED_USERS;
  }
  return JSON.parse(stored);
}

function saveUsers(users) {
  localStorage.setItem('nc_users', JSON.stringify(users));
}

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getUsers(); // ensure seed exists
    const saved = localStorage.getItem('nc_session');
    if (saved) setUser(JSON.parse(saved));
    setLoading(false);
  }, []);

  const login = (email, password) => {
    const users = getUsers();
    const found = users.find(u => u.email.toLowerCase() === email.toLowerCase() && u.password === password);
    if (!found) return { ok: false, error: 'Invalid email or password.' };
    const { password: _p, ...safe } = found;
    localStorage.setItem('nc_session', JSON.stringify(safe));
    setUser(safe);
    return { ok: true, user: safe };
  };

  const register = (name, email, password) => {
    const users = getUsers();
    if (users.find(u => u.email.toLowerCase() === email.toLowerCase())) {
      return { ok: false, error: 'An account with this email already exists.' };
    }
    const initials = name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
    const newUser = {
      id: Date.now(), name, email, password, role: 'client',
      avatar: initials, createdAt: new Date().toISOString().split('T')[0],
    };
    saveUsers([...users, newUser]);
    const { password: _p, ...safe } = newUser;
    localStorage.setItem('nc_session', JSON.stringify(safe));
    setUser(safe);
    return { ok: true, user: safe };
  };

  const logout = () => {
    localStorage.removeItem('nc_session');
    setUser(null);
  };

  const updateProfile = (updates) => {
    const users = getUsers();
    const idx = users.findIndex(u => u.id === user.id);
    if (idx === -1) return;
    users[idx] = { ...users[idx], ...updates };
    saveUsers(users);
    const { password: _p, ...safe } = users[idx];
    localStorage.setItem('nc_session', JSON.stringify(safe));
    setUser(safe);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, updateProfile }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() { return useContext(AuthContext); }
